import { sendAnalyticsTrack } from 'Utils/analytics.utils'
import { ActionConfig, ActionContext, IAction } from '../Action'

export class SkipAction implements IAction {
    static Id = 'Skip' as const
    constructor(
        private actionContext: ActionContext,
        private config?: ActionConfig
    ) {
        this.addToWorkbench()
    }

    addToWorkbench() {
        this.actionContext.workbenchUiAccessor?.toolbar.addAction(
            {
                id: 'skip-task',
                title: this.config?.title ?? 'Skip Task',
                type: 'button',
                onClick:
                    this.config?.onClick ??
                    (() => {
                        const errorAndWarningCount =
                            this.actionContext.studio.inputManager.getErrorAndWarningCount()
                        sendAnalyticsTrack('SkipTask_Clicked', {
                            ...this.actionContext.task.getCommonAnalyticsObject(),
                            duration_since_task_start: Math.floor(
                                this.actionContext.studio.taskManager.timer.getElapsedTime() / 1000
                            ),
                            warning_count: errorAndWarningCount.warningCount,
                            error_count: errorAndWarningCount.errorCount,
                        })
                        if (
                            this.actionContext.modalManager?.getModalMetaData(
                                'reject-or-skip-modal'
                            )
                        ) {
                            const skipTaskConfig =
                                this.actionContext.studio.taskConfig.assignment.task.config
                                    .skip_task_config
                            const feedbackConfig =
                                this.actionContext.studio.taskConfig.assignment.task.config
                                    .feedback_config
                            this.actionContext.modalManager?.updateModalMetaData(
                                'reject-or-skip-modal',
                                {
                                    isSkip: true,
                                    skipReasons: skipTaskConfig?.skip_reasons,
                                    isSkipReasonSelectionOptional:
                                        skipTaskConfig?.is_reason_optional,
                                    feedbackConfig,
                                }
                            )
                        }
                        this.actionContext.modalManager?.showModal('reject-or-skip-modal')
                        this.actionContext.task.ui?.updater.forceUpdate()
                    }),
                color: 'default',
                isCollapsed: this.config?.isCollapsed ?? true,
                disabled: this.config?.disabled ?? false,
                tooltip: this.config?.tooltip,
            },
            this.config?.placement
        )
    }

    removeFromWorkbench(): void {
        this.actionContext.workbenchUiAccessor?.toolbar.removeAction('skip-task')
    }
}
